import React from 'react';
import { translate } from '@utils/i18n';
import './ToggleSectionStyles.scss';
const namespace = 'features.settings.ip_assistant';
function ToggleSection({ aiOfficeEnabled, isUpdating, onToggle }) {
    return (React.createElement("section", { className: "ip-assistant-toggle-section" },
        React.createElement("fieldset", { className: "form__set--vertical--space" },
            React.createElement("div", { className: "form__field--x-full", style: { width: '411px' } },
                React.createElement("span", { className: "qmb-toggle-switch--check" },
                    React.createElement("input", { id: "ip-assistant-enable", type: "checkbox", className: "qmb-checkbox", checked: aiOfficeEnabled, disabled: isUpdating, onChange: onToggle }),
                    React.createElement("label", { htmlFor: "ip-assistant-enable" }, "\u00A0"),
                    React.createElement("label", { htmlFor: "ip-assistant-enable", className: "qmb-label" }, translate('toggle_label', { namespace })))))));
}
export default ToggleSection;
